import { Brand } from '@stax-core/types-omni';

export function isDocumentsPageHidden(brand: Brand) {
  /**
   * IF this page is hidden via brand (not present in brand.regSidebarItems)
   * THEN return true (do not show this page)
   */
  return !brand?.regSidebarItems?.includes('Documents/Statements');
}
